// Detección de instalación en pantalla de inicio (standalone) y OS móvil
// iter69 F3 — detección robusta: standalone/fullscreen/minimal-ui + referrer android-app://
export function isStandalone() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia) {
    for (const mode of ["standalone", "fullscreen", "minimal-ui"]) {
      if (window.matchMedia(`(display-mode: ${mode})`).matches) return true;
    }
  }
  if (window.navigator.standalone === true) return true;
  if (typeof document !== "undefined" && (document.referrer || "").startsWith("android-app://")) return true;
  return false;
}

export function detectMobileOS() {
  const ua = (typeof navigator !== "undefined" ? navigator.userAgent : "") || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  if (/Macintosh/.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1) return "ios";
  return "other";
}

// iter69 F3 — platform gate for push activation.
// iOS: Apple REALLY requires the PWA installed (standalone) for Web Push.
// Android: Chrome supports Web Push from the BROWSER — never block; the
// install guide is a non-blocking recommendation.
// Pure function (os, standalone) so it is testable with any user-agent.
export function canEnablePushForPlatform(os, standalone) {
  if (os === "ios") return standalone === true;
  return true;
}

export function canEnablePushHere() {
  return canEnablePushForPlatform(detectMobileOS(), isStandalone());
}

// iter69-B B2/B4 — gate puro del botón "Instalar en 1 toque":
// SOLO si no-iOS, no-standalone y beforeinstallprompt disparó.
// Pure function (os, standalone, promptFired) — testable con cualquier UA.
export function shouldShowInstallOneTap(os, standalone, promptFired) {
  if (os === "ios") return false;
  if (standalone === true) return false;
  return promptFired === true;
}

// iter69-B B3 — detección "Chrome en iPhone" (CriOS): hay que abrir en Safari.
export function isChromeOnIOSUA(ua) {
  return /CriOS/i.test(ua || "");
}

export function isChromeOnIOS() {
  return typeof navigator !== "undefined" && isChromeOnIOSUA(navigator.userAgent);
}
